
import "./App.css";
import { PriceComparison } from "./pages/PriceComparison/PriceComparison";

function App() {

  return (
     <main className=" mx-auto p-8 bg-white">
      <PriceComparison />
    </main>
  );
}

export default App;
